import { format } from 'owa-localize';
import getTodoRequestHeaders from './getTodoRequestHeaders';
import Task from './Task';

import { isSuccessStatusCode } from 'owa-http-status-codes';
import { makePatchRequest } from 'owa-ows-gateway';
import { TODO_API_UPDATE_TASK_FORMAT } from './constants';

/**
 * Calls makePatchRequest to update a task
 */
export default function updateTaskService(
    updates: Partial<Task>,
    itemIdToUpdate: string
): Promise<boolean> {
    const url = format(TODO_API_UPDATE_TASK_FORMAT, itemIdToUpdate);
    return makePatchRequest(
        url,
        updates,
        null /* correlationId */,
        true /* returnFullResponse */,
        getTodoRequestHeaders()
    )
        .then((response: Response) => {
            return isSuccessStatusCode(response.status);
        })
        .catch(err => {
            return false;
        });
}
